import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const jwtToken = localStorage.getItem('token');
  const BASE_URL = environment.apiBaseUrl;

  
  if (!req.url.startsWith(BASE_URL)) {
    return next(req);
  }
 
  const headers: Record<string, string> = {};
 
  
  const requiresApiKey =
    req.url.startsWith(`${BASE_URL}${environment.endpoints.ieee}`) ||
    req.url.startsWith(`${BASE_URL}${environment.endpoints.asme}`) ||
    req.url.startsWith(`${BASE_URL}${environment.endpoints.common}`);    
  if (requiresApiKey) {
    headers['X-API-KEY'] = 'my-secret-api-key'; 
  }
 

  if (jwtToken) {
    headers['Authorization'] = `Bearer ${jwtToken}`;
  }
 

  if (Object.keys(headers).length > 0) {
    const modifiedReq = req.clone({ setHeaders: headers });
    return next(modifiedReq);
  }
 
  return next(req);
};